import { Hero } from '@/components/sections/hero';

export function HomePage() {
  return (
    <div className="container">
      <Hero />
    </div>
  );
}